/**
 * The point of this class is to make extra line-break with double tabs on Enter key
 */

class Spacify {
    constructor(blocks) {
        this.blocks = blocks
        this.makeSpaceHandler()
    }
    makeSpaceHandler() {
        const paras = []
        this.blocks.forEach(block => {
            const para = block.querySelectorAll('p')
            para.forEach(p => {
                paras.push(p)
            })
        })
        paras.forEach(p => {
            if (p.innerHTML === '') p.innerHTML = '<br/>'
        })
    }
}

export default Spacify